import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GroupService, NgxToastrService } from "@core/services";
import { Company } from "@core/models";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-department-form',
  templateUrl: './department-form.component.html',
  styleUrls: ['./department-form.component.scss']
})
export class DepartmentFormComponent implements OnInit{

  form: FormGroup;
  loading = false;
  @Input() company: Company;
  @Input() isCreateDepartment: boolean;
  @Input() department: any;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private groupService: GroupService,
    private ngxToastrService: NgxToastrService,
    public translate: TranslateService,
  ) {
    this.form = this.fb.group({
      name: ["", [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit(): void {
     if (!this.isCreateDepartment && this.department) {
      this.form.patchValue({
        name: this.department.name,
      });
    }
  }

async onSubmit() {
  if (this.form.invalid) return;

  this.loading = true;

  const body = {
    name: this.form.value.name,
  };

  try {
    const action = this.isCreateDepartment
      ? this.groupService.postGroup(this.company?.uuid, body)
      : this.groupService.putGroup(this.company?.uuid, {
          uuid: this.department.uuid,
          ...body,
        });

    const result = await action.toPromise();

    const successMsgKey = this.isCreateDepartment
      ? 'company.company-detail.created-group'
      : 'company.company-detail.edit-group-succesful';

    const successMsg = await this.translate.get(successMsgKey).toPromise();
    this.ngxToastrService.typeSuccess(null, successMsg);

    this.activeModal.close(result);
  } catch (error) {
    const errorMsgKey = this.isCreateDepartment
      ? 'company.company-detail.error-create-group'
      : 'company.company-detail.error-edit-group';

    const errorMsg = await this.translate.get(errorMsgKey).toPromise();
    this.ngxToastrService.typeInfo(errorMsg, error?.error?.message || 'Error inesperado');
  } finally {
    this.loading = false;
  }
}

    closeModal() {
    this.activeModal.dismiss("Cross click");
  }
}
